import { useEffect, useState } from 'react';
import Sheet from './Sheet';
import { forgetMode } from '../lib/mode';
import { useApp } from '../lib/AppContext';

// Permanent deletion of the account and all its data (App Store requires it in the app), behind the password,
// or typing "XOÁ" for an account that signs in with Zalo/Google/Apple only.
export default function DeleteAccount() {
  const { api, native } = useApp();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  // null until known: an old phone account or one that set a password confirms with it.
  const [hasPassword, setHasPassword] = useState(null);
  useEffect(() => {
    if (open) api.get('/account/security').then((s) => setHasPassword(s.password_set)).catch(() => setHasPassword(true));
  }, [open, api]);

  const remove = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      // In the body, never the URL: URLs end up in server and proxy logs.
      await api.del('/account', hasPassword ? { password } : { confirm: password });
      // The account and its logins are gone: the app returns to its login screen, the website to its home page.
      forgetMode();
      if (native) await native.forget();
      else window.location.assign('/');
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" className="mx-auto min-h-11 px-4 text-sm font-medium text-error/80 underline" onClick={() => setOpen(true)}>
        Xóa tài khoản
      </button>
      <Sheet open={open} onClose={() => { setOpen(false); setError(null); setPassword(''); }} title="Xóa tài khoản?">
        <form onSubmit={remove} className="flex flex-col gap-4">
          <div className="text-sm">
            <p>Những dữ liệu sau sẽ bị xóa vĩnh viễn và không thể khôi phục:</p>
            <ul className="mt-2 list-disc space-y-1 pl-5">
              <li>Nhật ký bữa ăn, ảnh món ăn và buổi tập</li>
              <li>Thực đơn tuần và danh sách đi chợ</li>
              <li>Hồ sơ, ảnh đại diện, mục tiêu và link chia sẻ (link sẽ không mở được nữa)</li>
            </ul>
          </div>
          {hasPassword !== null && (
            <label className="flex flex-col gap-2">
              <span className="text-[15px] font-semibold">{hasPassword ? 'Nhập mật khẩu để xác nhận' : 'Gõ XOÁ để xác nhận'}</span>
              <input type={hasPassword ? 'password' : 'text'} required autoComplete={hasPassword ? 'current-password' : 'off'}
                className="input h-11 w-full rounded-[14px] border-line text-base" value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
          )}
          {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}
          <button type="submit" className="btn btn-error h-[54px] w-full rounded-2xl border-0 text-base font-bold" disabled={busy || !password}>
            {busy && <span className="loading loading-spinner loading-sm" />} Xóa vĩnh viễn
          </button>
        </form>
      </Sheet>
    </>
  );
}
